export enum DisplayPressureUnit {
  BAR = 'bar',
  SG = 'SG',
}

export type PrognosisSortColumn = 'validFromDate' | 'validToDate';
